import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class ManageCampaign extends HttpForm {
    account;
    slug;
    data = false;
    metrics = false;
    constructor(params) {
        super();
        this.account = params.account;
        this.slug = params.slug;
    }
    mount() {
        return Promise.all([
            this.showCampaign(),
            this.campaignMetrics(),
        ]).then(() => this.setLoadingState(true));
    }
    showCampaign() {
        return this.getCampaign()
            .then((response) => {
            this.data = response.data.data;
        })
            .catch(e => this.setError(e));
    }
    getCampaign() {
        const url = '/api/campaign/' + this.slug;
        return axios.get(url).catch(e => this.setError(e));
    }
    campaignMetrics() {
        const url = '/api/campaign/' + this.slug + '/metrics';
        return axios.get(url)
            .then((response) => {
            this.metrics = response.data.data;
        })
            .catch(e => this.setError(e));
    }
}
